/* Mr Car Mats — configurator stepper.
   A layer over the options app. It never removes or moves the app's inputs, it
   only adds a summary line and toggles classes, so selections and validation
   stay the app's job and this can be deleted without breaking the form.

   Why it exists: the page carries up to 12 required option groups stacked flat.
   Once a group is answered it collapses to one line, so the column shortens as
   you work down it instead of growing. A group with nothing chosen is NEVER
   collapsed, because hiding an unanswered required field would block add to
   cart with no visible reason. */
(function () {
  if (window.afbApoStepper) return;
  window.afbApoStepper = true;

  var esc = function (s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  };
  var text = function (el) { return el && el.innerText ? el.innerText.trim() : ''; };

  function label(group) {
    /* the app prints the title and the chosen value in one node, so "Colour"
       arrives as "Colour * Black". Everything before the required marker is
       the label. */
    var line = text(group.querySelector('.mw-stack__item')).split('\n')[0];
    return (line.indexOf('*') > -1 ? line.split('*')[0] : line).trim();
  }

  function visibleGroups() {
    var all = document.querySelectorAll('.mw-option');
    var out = [];
    for (var i = 0; i < all.length; i++) {
      var g = all[i];
      if (g.offsetParent !== null && g.offsetHeight > 0) out.push(g);
    }
    return out;
  }

  function paintSummary(group, index) {
    var bar = group.querySelector('[data-afb-summary]');
    if (!bar) {
      bar = document.createElement('button');
      bar.type = 'button';
      bar.className = 'afb-cfg__summary';
      bar.setAttribute('data-afb-summary', '');
      bar.addEventListener('click', function () {
        group.classList.toggle('afb-cfg--open');
      });
      group.insertBefore(bar, group.firstChild);
    }
    var chosen = group.querySelector('.mw-option__value--selected');
    var name = chosen ? text(chosen.querySelector('.mw-option__value-text')) : '';
    var price = chosen ? text(chosen.querySelector('.mws_option-price')) : '';
    /* swatch only options carry no text on the value, so the chosen name exists
       nowhere except the tail of the group's own title, "Colour * Black" */
    if (chosen && !name) {
      var line = text(group.querySelector('.mw-stack__item')).split('\n')[0];
      if (line.indexOf('*') > -1) name = line.split('*').slice(1).join('*').trim();
    }

    bar.innerHTML =
      '<span class="afb-cfg__n">' + index + '</span>' +
      '<span class="afb-cfg__lbl">' + esc(label(group)) + '</span>' +
      '<span class="afb-cfg__val">' + esc(name) +
        (price ? ' <em>' + esc(price) + '</em>' : '') + '</span>' +
      '<span class="afb-cfg__change">Change</span>';
  }

  function stickyHost() {
    var pf = document.querySelector('.product__info-container > div > product-form');
    return pf ? pf.parentElement : null;
  }

  /* The quantity block sits after every option group, which on this product put
     it 1,662px away from the button it belongs to. It carries a form=""
     attribute and lives outside the form, so moving it is safe. */
  function gatherBar() {
    var host = stickyHost();
    if (!host) return;
    var qty = document.querySelector('.product-form__quantity');
    if (qty && qty.parentElement !== host) {
      host.insertBefore(qty, host.querySelector('product-form'));
    }
  }

  function paintBar(groups) {
    var host = stickyHost();
    if (!host) return;
    var meta = host.querySelector('[data-afb-bar]');
    if (!meta) {
      meta = document.createElement('div');
      meta.className = 'afb-buybar';
      meta.setAttribute('data-afb-bar', '');
      host.insertBefore(meta, host.firstChild);
    }
    var done = 0;
    for (var i = 0; i < groups.length; i++) {
      if (groups[i].classList.contains('afb-cfg--done')) done++;
    }
    var price = text(document.querySelector('.product__info-container .price .price-item'));
    meta.innerHTML =
      '<span class="afb-buybar__price">' + esc(price) + '</span>' +
      '<span class="afb-buybar__prog">' + done + ' of ' + groups.length + ' chosen</span>';
  }

  function decorate() {
    var groups = visibleGroups();
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      g.classList.add('afb-cfg');
      paintSummary(g, i + 1);
      if (g.querySelector('.mw-option__value--selected')) {
        g.classList.add('afb-cfg--done');
      } else {
        g.classList.remove('afb-cfg--done', 'afb-cfg--open');
      }
    }
    gatherBar();
    paintBar(groups);
    watchPrice();
  }

  /* The bar repeats the price. While the real price is still on screen that
     reads as a duplication, which on a phone at the top of the page it always
     is, because the bar is pinned two lines below it. The bar's copy is hidden
     until the real one scrolls away. */
  function watchPrice() {
    var host = stickyHost();
    if (!host || window.afbPriceWatch) return;
    var flow = document.querySelector('.product__info-container > div:not(:has(> product-form)) .price');
    if (!flow || typeof IntersectionObserver !== 'function') return;
    window.afbPriceWatch = true;
    new IntersectionObserver(function (entries) {
      host.classList.toggle('afb-bar--price-hidden', entries[0].isIntersecting);
    }, { threshold: 0 }).observe(flow);
  }

  var pending = null;
  function schedule() {
    if (pending) clearTimeout(pending);
    pending = setTimeout(decorate, 120);
  }

  function start() {
    var root = document.querySelector('.mw-option') && document.querySelector('.mw-option').closest('form, .product__info-container');
    if (!root) { setTimeout(start, 400); return; }
    decorate();
    /* the app rebuilds its own DOM on every selection, which drops the summary
       lines, so everything is re-applied after it settles */
    new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
    root.addEventListener('change', schedule);
    root.addEventListener('click', schedule);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
